export default "__VITE_ASSET__DlcoKilp__"